import { Button } from "../ui/button";
import { ShieldCheck, Sparkles, Building2 } from "lucide-react";

export const Intro = ({ onStart }) => (
  <div className="animate-rise" data-testid="intro-screen">
    <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] font-semibold text-[#6C8EAD] mb-5">
      <Building2 className="h-4 w-4" /> Studio Scala Milano
    </div>
    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#2B3A42] leading-tight">
      Simulatore Credito Innovazione 4.0
    </h1>
    <div className="mt-6 space-y-1 text-[#5B6E78] text-base sm:text-lg leading-relaxed max-w-xl">
      <p>Stima prudenziale del credito d'imposta sul costo del personale impegnato</p>
      <p>in progetti di innovazione, anni 2021-2023.</p>
    </div>

    <div className="mt-8 flex flex-wrap gap-3">
      <span className="inline-flex items-center gap-1.5 rounded-full bg-[#EEF4EB] text-[#4F683E] text-xs font-medium px-3 py-1.5 border border-[#9CAF88]/40">
        <ShieldCheck className="h-3.5 w-3.5" /> Stima prudenziale
      </span>
      <span className="inline-flex items-center gap-1.5 rounded-full bg-[#E9F0F5] text-[#4F708C] text-xs font-medium px-3 py-1.5 border border-[#6C8EAD]/30">
        <Sparkles className="h-3.5 w-3.5" /> Innovazione tecnologica 4.0
      </span>
    </div>

    <Button
      data-testid="start-simulation-btn"
      onClick={onStart}
      className="mt-10 h-12 px-8 rounded-full bg-[#6C8EAD] hover:bg-[#4F708C] text-white text-base font-medium transition-colors"
    >
      Inizia simulazione
    </Button>
  </div>
);
